@if (recoverEligibilityLoading) {
  <div mat-dialog-content>
    <div class="action-selection__loading"
      [cfaLoading]="true">
    </div>
  </div>
}
@if (!recoverEligibilityLoading && (getEligibleForRecovery() | async)) {
  <div class="action-selection"
    [ngClass]="{'action-selection__desktop': !isMobile, 'action-selection__mobile': isMobile}"
    >
    <div mat-dialog-title fxLayout="column" fxLayoutAlign="center center">
      <div class="action-selection__title">{{name}}</div>
      <div class="action-selection__title">{{priority}}</div>
      <div class="action-selection__subtitle">What action do you want to take on this item?</div>
    </div>
    @if (actionOptions) {
      <div mat-dialog-content>
        <mat-radio-group [(ngModel)]="selectedValue">
          @for (section of actionOptions; track section.title) {
            <div fxLayout="column" fxLayoutAlign="space-around start">
              <div fxLayout="row">
                <div class="action-selection__section-title"
                  [ngClass]="{'action-selection__disabled-title': (section.sendResponseToGuest && (!eligibleForSpotEngagement || !hasEmail))}">
                  {{section.title}}
                </div>
                <help-text [helpText]="section.helpText" [displayOnLeft]="isMobile"></help-text>
              </div>
              @if (section.sendResponseToGuest && isSendDisabled) {
                <div class="action-selection__send-disabled-text">
                  {{allSendDisabledText}}
                </div>
              }
              @for (subsection of section.category; track subsection.subType) {
                <div class="action-selection__subsection">
                  @for (option of subsection.options; track option.title) {
                    <mat-radio-button
                      [value]="option.title"
                      [disabled]="section.sendResponseToGuest && (!eligibleForSpotEngagement || isSendDisabled || !hasEmail)"
                      (change)="optionChanged(subsection.subType, section.sendResponseToGuest)"
                      class="action-selection__option"
                      fxLayout="column"
                      fxLayoutAlign="space-around start">
                      {{option.title}}
                    </mat-radio-button>
                  }
                </div>
              }
              @if (section.sendResponseToGuest && !eligibleForSpotEngagement && !isP1SendingAllowedForCase) {
                <div
                  class="action-selection__priority-send-disabled">
                  {{prioritySendDisabledText}}
                </div>
              }
              @if (section.sendResponseToGuest && ((!eligibleForSpotEngagement && isP1SendingAllowedForCase) || (eligibleForSpotEngagement && !hasEmail))) {
                <div
                  class="action-selection__priority-send-disabled">
                  {{noEmailSendDisabledText}}
                </div>
              }
            </div>
          }
        </mat-radio-group>
        @if (selectedSubtype === closedSubtype || selectedSubtype === resolvedSubtype) {
          <div class="action-selection__resolve-warning-text">
            {{this.getWarningText()}}
          </div>
        }
        @if (type === spotCustomer && this.selectedValue !== null) {
          <div>
            <div class="action-selection__restaurant-recovery-title">Add a Note</div>
            <div class="action-selection__restaurant-recovery-body">
              This will be your only opportunity to add notes for Chick-fil-A One Contacts. These cannot be edited or deleted later.
            </div>
          </div>
        }
        @if (this.selectedValue !== null) {
          <div>
            <mat-form-field floatLabel="never" class="action-selection__note-container">
              <mat-placeholder class="action-selection__placeholder">Add a note (optional)</mat-placeholder>
              <textarea matInput
                cdkTextareaAutosize
                maxlength="500"
                class="action-selection__text-area"
                [ngModel]="note.updatedText"
                (keyup)="updateText($event)">
              </textarea>
              <mat-hint class="action-selection__disclaimer" align="left">
                *Do not enter sensitive guest details such as credit card numbers, emails, etc.
              </mat-hint>
              <mat-hint class="action-selection__character-count" align="end">{{note.updatedText.length}} / 500</mat-hint>
            </mat-form-field>
          </div>
        }
      </div>
    }
    @if (!actionOptions) {
      <div mat-dialog-content>
        <div class="action-selection__loading"
          [cfaLoading]="true">
        </div>
      </div>
    }
    <div [ngClass]="{'action-selection__mobile-footer-sticky': isMobile}">
      <div mat-dialog-actions fxLayout="row" fxLayoutAlign="space-around center" class="action-selection__buttons">
        <button mat-button (click)="cancelClicked.emit()" class="action-selection__cancel-button">Cancel</button>
        <button mat-button
          [ngClass]="this.selectedValue === null ? 'action-selection__send-button-disabled' : 'action-selection__send-button'"
          (click)="startRespondFlow()"
          [disabled]="this.selectedValue === null">
          Continue
        </button>
      </div>
    </div>
  </div>
}

@if (!recoverEligibilityLoading && !(getEligibleForRecovery() | async)) {
  <div>
    <mat-icon class="action-selection__warning-icon">warning</mat-icon>
    <div mat-dialog-title fxLayout="column" fxLayoutAlign="center center">
      <div class="action-selection__ineligible-title">{{ineligibleHeaderText}}</div>
    </div>
    <div class="action-selection__ineligible-body-text">{{ineligibleBodyText}}</div>
    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="space-around center" class="action-selection__buttons">
      <button mat-button (click)="cancelClicked.emit()" class="action-selection__ineligible-button">{{ineligibleButtonText}}</button>
    </div>
  </div>
}
